module.exports = __webpack_public_path__ + "img/ea9f1f1.jpg";